(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1045],{

/***/ 91045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content025": function() { return /* binding */ Content025; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87900);
/* harmony import */ var shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32667);
/* harmony import */ var _Content025_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68055);
/* harmony import */ var _Content025_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Content025_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var Content025 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var name = (ref1 = payload === null || payload === void 0 ? void 0 : payload.name) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var description = (ref2 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    var phone = (ref3 = payload === null || payload === void 0 ? void 0 : payload.phone) !== null && ref3 !== void 0 ? ref3 : "";
    var ref4;
    var email = (ref4 = payload === null || payload === void 0 ? void 0 : payload.email) !== null && ref4 !== void 0 ? ref4 : "";
    var ref5;
    var photo = (ref5 = payload === null || payload === void 0 ? void 0 : payload.photo) !== null && ref5 !== void 0 ? ref5 : {};
    var ref6;
    var template = (ref6 = payload === null || payload === void 0 ? void 0 : payload.template) !== null && ref6 !== void 0 ? ref6 : "light";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Content025_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrapper), (_Content025_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[template]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Content025_module_scss__WEBPACK_IMPORTED_MODULE_4___default().block),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .RenderIf */ .$b, {
                        viewMode: shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_3__/* .VIEW_MODES.MOBILE */ .nY.MOBILE,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading3 */ .aC, {
                            className: (_Content025_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_Content025_module_scss__WEBPACK_IMPORTED_MODULE_4___default().image),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .ImageLite */ .NH, {
                            image: photo,
                            className: (_Content025_module_scss__WEBPACK_IMPORTED_MODULE_4___default().photo)
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Content025_module_scss__WEBPACK_IMPORTED_MODULE_4___default().content),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .RenderIf */ .$b, {
                                viewMode: shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_3__/* .VIEW_MODES.DESKTOP */ .nY.DESKTOP,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading3 */ .aC, {
                                    className: (_Content025_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                                    children: title
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading6 */ .Cd, {
                                className: (_Content025_module_scss__WEBPACK_IMPORTED_MODULE_4___default().name),
                                children: name
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Paragraph */ .nv, {
                                color: "grey",
                                className: (_Content025_module_scss__WEBPACK_IMPORTED_MODULE_4___default().description),
                                children: description
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_Content025_module_scss__WEBPACK_IMPORTED_MODULE_4___default().contacts),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: "tel:".concat(phone),
                                        className: (_Content025_module_scss__WEBPACK_IMPORTED_MODULE_4___default().detail),
                                        children: phone
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: "mailto:".concat(email),
                                        className: (_Content025_module_scss__WEBPACK_IMPORTED_MODULE_4___default().detail),
                                        children: email
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content025);


/***/ }),

/***/ 68055:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content025_wrapper__iMpNJ","light":"Content025_light__VDlJ9","grey":"Content025_grey__iRkw3","block":"Content025_block__UKkkP","content":"Content025_content__fV3pi","image":"Content025_image__I5SW_","photo":"Content025_photo___Jsp2","title":"Content025_title__Vq5Kr","name":"Content025_name__8Lgdk","description":"Content025_description__rBhfh","contacts":"Content025_contacts__3xuKq","detail":"Content025_detail__xDUlh"};

/***/ })

}]);